import query from "./modules/query";
import course from "./modules/course";

export default {
  query,
  course,
};
